import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import bsCustomFileInput from "bs-custom-file-input";
import { DataService } from "src/app/shared/Services/data.service";
import {
  maxDigitsValidator,
  maxDigitsValidatorforConfig,
} from "src/app/shared/Services/custom-validator";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

@Component({
  selector: "app-device",
  templateUrl: "./deviceadd.component.html",
  styleUrls: ["./deviceadd.component.scss"],
})
export class DeviceComponent implements OnInit {
  typesubmit: boolean;
  deviceForm: FormGroup;
  machineTypeform: FormGroup;
  pins: FormArray;
  analog: FormArray;
  ct: FormArray;
  curSystem: FormArray;
  isAdd: boolean = false;
  breadCrumbItems: Array<{}>;
  deviceList: any = [];
  custId: any = "";
  loginRole: any = "";
  currentPage = 1;
  itemsPerPage = 5;
  isEdit: boolean = false;
  id: "";
  searchTerm: any;
  pageSize;
  submit: boolean = false;
  delMachId = "";
  machineTypeList: any = [];
  partConfigOption = [true, false];
  selectedOptionIndex: number = -1;
  phaseSequence: string[] = ["1P2W", "2P3W", "3P3W", "3P4W"];
  FrequencySequency: string[] = ["60Hz", "50Hz"];
  partcount_Type = [
    { value: 'digital', label: 'Digital' },
    { value: 'AI', label: 'AI' },
    { value: 'edge', label: 'Edge Part' },
  ];
  Frequency_State = [
    { label: 'enable', value: 1 },
    { label: 'disable', value: 0 }
  ];
  ctRateSequence = [
    { label: '<=100A', value: 2 },
    { label: '>100A', value: 4 }
  ];

  departmentData: any = [];
  // aiVersionList:any=[]
  // departmentData:any=[]
  constructor(
    public formBuilder: FormBuilder,
    private dataservice: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private http: HttpClient
  ) {
    let userDetails = JSON.parse(sessionStorage.getItem("currentUser"));
    let user = userDetails["user"];
    this.loginRole = user["role"];
  }

  ngOnInit() {
    // this.loginRole = "SUPERADMIN"
    this.custId = this.route.snapshot.paramMap.get("id");

    this.getMachineType();
    if (this.custId) {
      this.getCustDepartment(this.custId);
      this.custDevices(this.custId);
    } else {
      this.getDevices();
      this.getDepartment();
    }

    this.breadCrumbItems = [
      { label: "Configuration" },
      { label: "Machine", active: true },
    ];
    bsCustomFileInput.init();
    // this.getAiModel()
  }

  getCustDepartment(custId) {
    this.dataservice
      .get(`department?custId=${custId}`)
      .subscribe((res: any) => {

        this.departmentData = res.data;
      });
  }
  getDepartment() {
    this.dataservice.get(`department`).subscribe((res: any) => {

      this.departmentData = res.data;
    });
  }

  initializeForm1() {
    const eMicConfigData = [];
    this.deviceForm = this.formBuilder.group({
      deviceId: ["", [Validators.required, Validators.maxLength(12)]],
      machineId: [""],
      deviceName: ["", [Validators.required]],
      deviceType: ["", Validators.required],
      deviceModelNo: ["", [Validators.required]],
      deviceController: ["", [Validators.required]],
      deviceMake: ["", [Validators.required]],
      devicesupplier: ["", [Validators.required]],
      deviceage: ["", [Validators.required, maxDigitsValidator(3)]],
      voltage: ["", [Validators.required, maxDigitsValidator(3)]],
      costperHour: [0, [Validators.required]],
      powerfactor: ["", [Validators.required, maxDigitsValidator(3)]],
      current: ["", [Validators.required, maxDigitsValidator(3)]],
      axis: ["", [Validators.required, maxDigitsValidator(3)]],
      targetPart: ["", [Validators.required]],
      spindle: ["", [Validators.required, maxDigitsValidator(3)]],
      oee: ["", Validators.required],
      licensing: [3],
      meterSupplier: ["", Validators.required],
      meterModel: ["", [Validators.required]],
      connectionType: ["", [Validators.required]],
      pins: this.formBuilder.array([]),
      inpins: this.formBuilder.array([]),
      pindebounce: this.formBuilder.array([]),
      outpins: this.formBuilder.array([]),
      analog: this.formBuilder.array([]),
      ct: this.formBuilder.array([]),
      curSystem: this.formBuilder.array([]),
      partcountType: [""],
      // aiVersion: ["", [Validators.required]],
      departmentName: ["", Validators.required],
      departmentId: ["", Validators.required],
      transmissionFrequency: 30,
      analogscanFreq: [
        0,
        [
          Validators.pattern(/^\d*\.?\d*$/),
          maxDigitsValidatorforConfig(4, 5),
        ],
      ],
      analogpostFreq: [
        0,
        [
          Validators.pattern(/^\d*\.?\d*$/),
          maxDigitsValidatorforConfig(4, 5),
        ],
      ],
      eMICConfig: this.formBuilder.array(
        eMicConfigData.map((item) => this.createEMICConfig(item))
      ),
    });
 this.deviceForm.get("departmentName")?.valueChanges.subscribe((value) => {

  const selectedDepartment = this.departmentData.find(
    (val) => val.departmentName === value
  );

  if (selectedDepartment) {
    this.deviceForm.get("departmentId")?.setValue(selectedDepartment.departmentId);
  } else {
    this.deviceForm.get("departmentId")?.setValue('');
  }

});
    this.deviceForm.get("oee")?.valueChanges.subscribe((value) => {
      const deviceTypeControl = this.deviceForm.get("partcountType");
      const pinsArray = this.deviceForm.get("pins") as FormArray;

      if (value === "no_part") {
        deviceTypeControl?.clearValidators();
          deviceTypeControl?.setValue('');
            while (pinsArray.length !== 0) {
      pinsArray.removeAt(0);
    }
      } else {
        deviceTypeControl?.setValidators(Validators.required);
      }

      deviceTypeControl?.updateValueAndValidity();
    });
    const initialOee = this.deviceForm.get("oee")?.value;
    this.deviceForm.get("oee")?.setValue(initialOee);

  }

  initializeForm() {
    const eMicConfigData = [
      {
        eMICName: ["Frequency", [Validators.required]],
        eMICType: "50Hz",
      },
      {
        eMICName: ["Phase Sequence", [Validators.required]],
        eMICType: "3P4W",
      },
      {
        eMICName: "PGA Gain Configuration",
        eMICType: 21845,
      },
    ];
    this.deviceForm = this.formBuilder.group({
      deviceId: ["", [Validators.required, Validators.maxLength(12)]],
      machineId: [""],
      deviceName: ["", [Validators.required]],
      deviceType: ["", Validators.required],
      deviceModelNo: ["", [Validators.required]],
      deviceController: ["", [Validators.required]],
      deviceMake: ["", [Validators.required]],
      devicesupplier: ["", [Validators.required]],
      deviceage: ["", [Validators.required, maxDigitsValidator(3)]],
      voltage: ["", [Validators.required, maxDigitsValidator(3)]],
      costperHour: [0, [Validators.required]],
      powerfactor: ["", [Validators.required, maxDigitsValidator(3)]],
      current: ["", [Validators.required, maxDigitsValidator(3)]],
      axis: ["", [Validators.required, maxDigitsValidator(3)]],
      targetPart: ["", [Validators.required]],
      spindle: ["", [Validators.required, maxDigitsValidator(3)]],
      oee: ["", Validators.required],
      licensing: [3],
      meterSupplier: ["", Validators.required],
      meterModel: ["", [Validators.required]],
      connectionType: ["", [Validators.required]],
      pins: this.formBuilder.array([]),
      inpins: this.formBuilder.array([]),
      pindebounce: this.formBuilder.array([]),
      outpins: this.formBuilder.array([]),
      analog: this.formBuilder.array([]),
      analogscanFreq: [
        0,
        [
          Validators.pattern(/^\d*\.?\d*$/),
          maxDigitsValidatorforConfig(4, 5),
        ],
      ],
      analogpostFreq: [
        0,
        [
          Validators.pattern(/^\d*\.?\d*$/),
          maxDigitsValidatorforConfig(4, 5),
        ],
      ],
      ct: this.formBuilder.array([]),
      curSystem: this.formBuilder.array([]),
      partcountType: [""],
      departmentName: ["", Validators.required],
      departmentId: ["", Validators.required],

      // aiVersion: ["", [Validators.required]],
      transmissionFrequency: 30,
      eMICConfig: this.formBuilder.array(
        eMicConfigData.map((item) => this.createEMICConfig(item))
      ),
    });
    this.deviceForm.get("departmentName")?.valueChanges.subscribe((value) => {

  const selectedDepartment = this.departmentData.find(
    (val) => val.departmentName === value
  );

  if (selectedDepartment) {
    this.deviceForm.get("departmentId")?.setValue(selectedDepartment.departmentId);
  } else {
    this.deviceForm.get("departmentId")?.setValue('');
  }

});

    this.deviceForm.get("oee")?.valueChanges.subscribe((value) => {
      const deviceTypeControl = this.deviceForm.get("partcountType");

      if (value === "no_part") {
        deviceTypeControl?.clearValidators();
        deviceTypeControl?.setValue('');
      } else {
        deviceTypeControl?.setValidators(Validators.required);
      }

      deviceTypeControl?.updateValueAndValidity();
    });
    const initialOee = this.deviceForm.get("oee")?.value;
    this.deviceForm.get("oee")?.setValue(initialOee);
  }
  onpartTypeChange(e: any) {
    const selectedValue = e?.target?.value ?? e;
    this.deviceForm.get("partcountType")?.setValue(selectedValue);

    const arrayControl = this.deviceForm.get("pins") as FormArray;
    if (selectedValue === "digital") {
      this.addDigitalPin();
    } else if (selectedValue === 'AI' || selectedValue === 'edge') {
      arrayControl.clear();
      this.selectedOptionIndex = -1;
    } else {
      arrayControl.controls.forEach((group: AbstractControl) => {
        group.get('pinName')?.clearValidators();
        group.get('pinType')?.clearValidators();
        group.updateValueAndValidity();
      });
    }
  }
  onInput(event: Event, i: any) {
    const input = event.target as HTMLInputElement;
    if (parseFloat(input.value) < 0) {
      this.eMICConfigArray.at(i).get("eMICType")?.setValue("");
      input.value = "";
    }
  }

  get eMICConfigArray(): FormArray {
    return this.deviceForm.get("eMICConfig") as FormArray;
  }
  getDevices() {
    this.dataservice.get("api/device").subscribe((res) => {
      this.deviceList = res;
    });
  }

  custDevices(id) {
    this.dataservice.get(`api/device?custId=${id}`).subscribe((res) => {
      this.deviceList = res;
    });
  }

  normalizePartConfigValue(value: any): boolean {
    if (typeof value === "string") {
      return value.toLowerCase() === "true";
    }
    return Boolean(value);
  }

  private isK2V11Supplier(value: string | null | undefined): boolean {
    return ["K2-V1.1", "K2V1.1"].includes((value || "").trim());
  }

  addDigitalPin() {
    const arrayControl = this.deviceForm.get("pins") as FormArray;
    let previousArray = arrayControl.value;
    if (this.normalizePartConfigValue(previousArray[0]?.partConfig)) {
      this.selectedOptionIndex = 0;
    } else {
      this.selectedOptionIndex = -1;
    }
    if (arrayControl.length < 2) {
      arrayControl.push(
        this.formBuilder.group({
          index: new FormControl({
            value: arrayControl.length,
            disabled: true,
          }),
          pinName: ["PIN1", [Validators.required]],
          pinType: ["counter", [Validators.required]],
          partConfig: [true],
        })
      );
    }
  }

  isOptionDisabled(index: number): boolean {
    return index == this.selectedOptionIndex;
  }

  addAnalogPin() {
    const arrayControl = this.deviceForm.get("analog") as FormArray;
    if (arrayControl.length < 4) {
      arrayControl.push(
        this.formBuilder.group({
          index: new FormControl({
            value: arrayControl.length,
            disabled: true,
          }),
          analogName: ["Demo", [Validators.required]],
          portType: ["None", [Validators.required]],
          sensorOutputType: [Number(-1), [Validators.required]],
          channel: [1, [Validators.required]],
          upperLimit: [
            0,
            [
              Validators.pattern(/^\d*\.?\d*$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
          lowerLimit: [
            0,
            [
              Validators.pattern(/^\d*\.?\d*$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
          scaleFactor: [
            0,
            [
              Validators.pattern(/^\d*\.?\d*$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
          ctRatio: [
            0,
            [
              Validators.pattern(/^\d*\.?\d*$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
          divisionFactor: [
            0,
            [
              Validators.pattern(/^\d*\.?\d*$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
          multiFactor: [
            0,
            [
              Validators.pattern(/^\d*\.?\d*$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
        })
      );
    }
  }

  addCurrentPin() {
    const arrayControl = this.deviceForm.get("ct") as FormArray;
    if (arrayControl.length < 2) {
      arrayControl.push(
        this.formBuilder.group({
          index: new FormControl({
            value: arrayControl.length,
            disabled: true,
          }),
          // ctName: ["", [Validators.required]],
          ctRate: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
          ctStatus: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
          ctpartcountPin: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],

          actualIdletime: [
            0,
            [Validators.required, maxDigitsValidatorforConfig(4, 5)],
          ],
          mode: [1, [Validators.required]],
          upperLimit: [
            0,
            [
              Validators.required,
              Validators.pattern(/^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
          upperSet: [
            0,
            [
              Validators.required,
              Validators.pattern(/^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
          lowerLimit: [
            0,
            [
              Validators.required,
              Validators.pattern(/^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
          lowerSet: [
            0,
            [
              Validators.required,
              Validators.pattern(/^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/),
              maxDigitsValidatorforConfig(4, 5),
            ],
          ],
        })
      );
    }
  }


  removeArrayItem(index: number) {
    const arrayControl = this.deviceForm.get("pins") as FormArray;
    arrayControl.removeAt(index);
    let previousArray = arrayControl.value;
    if (this.normalizePartConfigValue(previousArray[0]?.partConfig)) {
      this.selectedOptionIndex = 0;
    } else {
      this.selectedOptionIndex = -1;
    }
    for (let i = index; i < arrayControl.length; i++) {
      arrayControl.at(i).get("index").setValue(i);
    }
  }

  onMeterChange(e) {
    this.deviceForm.get("meterModel")?.setValue("");
    this.deviceForm.get("partcountType")?.setValue("");

    const ctArray = this.deviceForm.get("ct") as FormArray;
    let eMicConfigData = [];

    if (e === "Wimera-K2") {
      (this.deviceForm.get("pins") as FormArray).clear();
      this.selectedOptionIndex = -1;
      eMicConfigData = [
        {
          eMICName: ["Frequency", [Validators.required]],
          eMICType: "50Hz",
        },
        {
          eMICName: ["Phase Sequence", [Validators.required]],
          eMICType: "3P4W",
        },
        {
          eMICName: "PGA Gain Configuration",
          eMICType: 21845,
        },
      ];

      if (ctArray.length > 0) {
        ctArray.clear();
      }
    } else if (this.isK2V11Supplier(e)) {
      (this.deviceForm.get("pins") as FormArray).clear();
      this.selectedOptionIndex = -1;
      eMicConfigData = [
        {
          eMICName: ["State", [Validators.required]],
          eMICType: 1,
        },
        {
          eMICName: ["Post Frequency", [Validators.required]],
          eMICType: "",
        },
        {
          eMICName: ["Frequency", [Validators.required]],
          eMICType: "50Hz",
        },
        {
          eMICName: ["Phase Sequence", [Validators.required]],
          eMICType: "3P4W",
        },
        {
          eMICName: ["CT Rate", [Validators.required]],
          eMICType: 2,
        },
      ];

      if (ctArray.length === 0) {
        ctArray.push(
          this.formBuilder.group({
            index: new FormControl({ value: 0, disabled: true }),
            ctRate: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
            ctStatus: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
            ctpartcountPin: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
            actualIdletime: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
            mode: [1, [Validators.required]],
            upperLimit: [
              0,
              [
                Validators.required,
                Validators.pattern(/^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/),
                maxDigitsValidatorforConfig(4, 5),
              ],
            ],
            upperSet: [
              0,
              [
                Validators.required,
                Validators.pattern(/^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/),
                maxDigitsValidatorforConfig(4, 5),
              ],
            ],
            lowerLimit: [
              0,
              [
                Validators.required,
                Validators.pattern(/^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/),
                maxDigitsValidatorforConfig(4, 5),
              ],
            ],
            lowerSet: [
              0,
              [
                Validators.required,
                Validators.pattern(/^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/),
                maxDigitsValidatorforConfig(4, 5),
              ],
            ],
          })
        );
      } else if (ctArray.length > 1) {
        while (ctArray.length > 1) {
          ctArray.removeAt(ctArray.length - 1);
        }
      }

      if (ctArray.length > 0) {
        ctArray.at(0).get("index")?.setValue(0);
      }
    } else {
      eMicConfigData = [];
    }

    this.updateEMICConfig(eMicConfigData);
  }
  get filteredPartcountTypes() {
    const supplier = this.deviceForm.get('meterSupplier')?.value;
    if (this.isK2V11Supplier(supplier)) {
      return this.partcount_Type.filter((type) => type.value !== 'AI');
    }
    return this.partcount_Type;
  }

  get showDigitalPinAddButton(): boolean {
    const supplier = this.deviceForm?.get('meterSupplier')?.value;
    const partCountType = this.deviceForm?.get('partcountType')?.value;
    const pinsLength = (this.deviceForm?.get('pins') as FormArray)?.length || 0;

    return supplier === 'Wimera-K2' && partCountType === 'digital' && pinsLength < 2 && this.loginRole !== 'CUSTOMER';
  }
  getstatus(e) {
    let eMicConfigData = []
    if (e === 0) {
      eMicConfigData = [
        {
          eMICName: ["State", [Validators.required]],
          eMICType: 0,
        }
      ];
    } else {
      eMicConfigData = [
        {
          eMICName: ["State", [Validators.required]],
          eMICType: 1,
        },
        {
          eMICName: ["Post Frequency", [Validators.required]],
          eMICType: "",
        },
        {
          eMICName: ["Frequency", [Validators.required]],
          eMICType: "50Hz",
        },
        {
          eMICName: ["Phase Sequence", [Validators.required]],
          eMICType: "3P4W",
        },
        {
          eMICName: ["CT Rate", [Validators.required]],
          eMICType: 2,
        },
      ];
    }
    this.updateEMICConfig(eMicConfigData);

  }
  updateEMICConfig(eMicConfigData: any[]) {
    const eMicArray = this.deviceForm.get("eMICConfig") as FormArray;
    eMicArray.clear();

    eMicConfigData.forEach(item => {
      eMicArray.push(this.createEMICConfig(item));
    });
  }


  // onpartcountTypeChange(e:any) {
  //   this.deviceForm.get("aiVersion").setValue("");
  // }

  ondeviceTypeChange(e) {

    if (e !== "CNC") {
      this.deviceForm.get("axis").setValue(0);
      this.deviceForm.get("spindle").setValue(0);
    }
  }
  onaiVersionChange(e) {

  }

  onOEEChange(e) {

    if (e !== "parts") {
      this.deviceForm.get("targetPart").setValue(0);
    }
  }
  removeoutpinItem(index: number) {
    const arrayControl = this.deviceForm.get("outpins") as FormArray;
    arrayControl.removeAt(index);
    for (let i = index; i < arrayControl.length; i++) {
      arrayControl.at(i).get("index").setValue(i);
    }
  }
  removeAnalogItem(index: number) {
    const arrayControl = this.deviceForm.get("analog") as FormArray;
    arrayControl.removeAt(index);
    for (let i = index; i < arrayControl.length; i++) {
      arrayControl.at(i).get("index").setValue(i);
    }
  }
  removeCurrentItem(index: number) {
    const arrayControl = this.deviceForm.get("ct") as FormArray;
    arrayControl.removeAt(index);
    for (let i = index; i < arrayControl.length; i++) {
      arrayControl.at(i).get("index").setValue(i);
    }
  }
  removeCurrentSystemItem(index: number) {
    const arrayControl = this.deviceForm.get("curSystem") as FormArray;
    arrayControl.removeAt(index);
    for (let i = index; i < arrayControl.length; i++) {
      arrayControl.at(i).get("index").setValue(i);
    }
  }
  get type() {
    return this.deviceForm.controls;
  }
  get form() {
    return this.machineTypeform.controls;
  }
  createEMICConfig(configData: any): FormGroup {
    return this.formBuilder.group({
      eMICName: configData.eMICName,
      eMICType: [configData.eMICType, Validators.required],
    });
  }
  updateValue(index: number) {
    const control = this.deviceForm.get(`analog.${index}.sensorOutputType`);
    if (control) {
      control.setValue(Number(control.value));
    }
  }
  private buildPayload(formValue: any): any {
  const payload = { ...formValue };
  
  if (payload.meterSupplier === 'Wimera-K2') {
    payload.ct=[];
  }
  
  return payload;
}
  typeSubmit() {
    this.typesubmit = true;
    this.deviceForm.enable();
    if (this.deviceForm.status == "INVALID") {
      if (this.isEdit) {
        this.disableParams();
      }
      return;
    } else {
       const formValue = this.deviceForm.value;
    const payload = this.buildPayload(formValue);
      if (this.isEdit) {
        let params = {
          id: this.id,
          custId: this.custId,
        };
        // Update API
        if (this.loginRole == "SUPERADMIN") {
          this.dataservice
            .put(
              `api/device/` + params["id"] + "/" + params["custId"],
              payload
            )
            .subscribe(
              (res) => {

                if (res) {
                  this.toastr.success("Machine Updated Successfully");
                  this.cancel();
                  this.custDevices(this.custId);
                } else {
                  // Do Nothing
                }
              },
              (error) => {
                this.toastr.error(error.message)
              }
            );
        } else {
          this.dataservice
            .put(
              `api/device/` + params["id"] + "/" + params["custId"],
              payload
            )
            .subscribe(
              (res) => {

                if (res) {
                  this.toastr.success("Machine Updated Successfully");
                  this.cancel();
                  this.getDevices();
                } else {
                  // Do Nothing
                }
              },
              (error) => {
                this.toastr.error(error.message)
              }
            );
        }
      } else {
        // Adding API
        if (this.loginRole == "SUPERADMIN") {
          this.dataservice
            .post(`api/device?custId=${this.custId}`, payload)
            .subscribe(
              (res) => {

                if (res) {

                  this.createCertificate(this.deviceForm.value["deviceId"]);
                  this.toastr.success("Machine added Successfully");
                  this.cancel();
                  this.custDevices(this.custId);
                } else {
                  // Do Nothing
                }
              },
              (error) => {
                this.toastr.error(error.message);
              }
            );
        } else {
          this.dataservice
            .post(`api/device`, payload)
            .subscribe(
              (res) => {

                if (res) {
                  this.createCertificate(this.deviceForm.value["deviceId"]);

                  this.toastr.success("Machine added Successfully");
                  this.cancel();
                  this.getDevices();
                } else {
                  // Do Nothing
                }
              },
              (error) => {
                this.toastr.error(error.message);
              }
            );
        }
      }
    }
  }
  createCertificate(id) {
    var params = {
      deviceID: id,
    };
    this.dataservice
      .machineApi(
        "machineCertificate",
        params
      )
      .subscribe((res) => {
        if (res["certs_created"] === "Yes") {
          this.toastr.success("Certificate Created Successfully");
        } else {
          this.toastr.warning("Certificate Not Created");
        }
      });
  }
  deleteCertificate(id) {
    const body = JSON.stringify({ deviceID: id }); // Convert body to JSON string
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    this.dataservice
      .machineDeleteApi('machineCertificate', body
      )
      .subscribe((res) => {
        if (res["certs_deleted"] === "Yes") {
          this.toastr.success("Certificate Deleted Successfully");
        } else {
          this.toastr.warning("Certificate Not Deleted");
        }
      });
  }
  adddevice() {
    this.initializeForm();
    this.isAdd = true;
    this.addAnalogPin();
    this.addCurrentPin();
    this.addinpins();
    this.addCurrentSystem();
    this.addpindebounce();
    this.addoutpins();
  }
    addCurrentSystem() {
    const arrayControl = this.deviceForm.get("curSystem") as FormArray;
    arrayControl.push(
      this.formBuilder.group({
        index: new FormControl({
          value: arrayControl.length,
          disabled: true,
        }),
        idleTHDmA: [0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
        minValidCurrent: [0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
        maxValidCurrent: [0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
        noiseVarienceTHD: [ 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
        stateChangeHystresis: [ 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
        minStateDuration: [0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
        confidenceTHD: [0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
        deviationRange: [0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
        preConfigCycleTime: [ 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
        sampleWindow: [ 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
      })
    );
  }
  addinpins() {
    const arrayControl = this.deviceForm.get("inpins") as FormArray;
    if (arrayControl.length < 2) {
      arrayControl.push(
        this.formBuilder.group({
          index: new FormControl({
            value: arrayControl.length,
            disabled: true,
          }),
          inpinStatus: [1, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
          inpinScanFrequency: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
          inpinPostFrequency: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
        })
      );
    }
  }
   addpindebounce() {
    const arrayControl = this.deviceForm.get("pindebounce") as FormArray;
      arrayControl.push(
        this.formBuilder.group({
          index: new FormControl({
            value: arrayControl.length,
            disabled: true,
          }),
          io1: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
          io2: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
          io3: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
          io4: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
        })
      );
  }
  addoutpins() {
    const arrayControl = this.deviceForm.get("outpins") as FormArray;
    if (arrayControl.length < 2) {
      arrayControl.push(
        this.formBuilder.group({
          index: new FormControl({
            value: arrayControl.length,
            disabled: true,
          }),
          outpinStatus: [1, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
          outpinTimeDuration: [0, [Validators.required, maxDigitsValidatorforConfig(4, 5)]],
        })
      );
    }
  }
  disableParams() {
    if (this.loginRole == "SUPERADMIN") {
      const digitalPins = this.deviceForm.get("pins") as FormArray;
      digitalPins.controls.forEach((control) => {
        control.get("index").disable();
        control.get("pinName").enable();
        control.get("pinType").enable();
        control.get("partConfig").enable();
      });

      const inpins = this.deviceForm.get("inpins") as FormArray;
      inpins.controls.forEach((control) => {
        control.get("index").disable();
        control.get("inpinStatus").enable();
        control.get("inpinScanFrequency").enable();
        control.get("inpinPostFrequency").enable();
      });
        const pindebounce = this.deviceForm.get("pindebounce") as FormArray;
      pindebounce.controls.forEach((control) => {
        control.get("index").disable();
        control.get("io1").enable();
        control.get("io2").enable();
        control.get("io3").enable();
        control.get("io4").enable();
      });
      const outpins = this.deviceForm.get("outpins") as FormArray;
      outpins.controls.forEach((control) => {
        control.get("index").disable();
        control.get("outpinStatus").enable();
        control.get("outpinTimeDuration").enable();
      });

      // Disable analog signals
      const analogSignals = this.deviceForm.get("analog") as FormArray;
      analogSignals.controls.forEach((control) => {
        control.get("index").disable();
        control.get("analogName").enable();
        control.get("portType").enable();
        control.get("sensorOutputType").enable();
        control.get("channel").enable();
        control.get("upperLimit").enable();
        control.get("lowerLimit").enable();
        control.get("scaleFactor").enable();
        control.get("ctRatio").enable();
        control.get("divisionFactor").enable();
        control.get("multiFactor").enable();
      });

      // Disable CTs
      const cts = this.deviceForm.get("ct") as FormArray;
      cts.controls.forEach((control) => {
        // control.get("index").disable();
        // control.get("ctName").enable();
        control.get("ctRate").enable();
        control.get("ctStatus").enable();
        control.get("ctpartcountPin").enable();
        control.get("actualIdletime").enable();
        control.get("mode").enable();
        control.get("upperLimit").enable();
        control.get("upperSet").enable();
        control.get("lowerLimit").enable();
        control.get("lowerSet").enable();
      });

      const cSystem = this.deviceForm.get("curSystem") as FormArray;
      cSystem.controls.forEach((control) => {
        control.get("index").disable();
        control.get("idleTHDmA").enable();
        control.get("minValidCurrent").enable();
        control.get("maxValidCurrent").enable();
        control.get("noiseVarienceTHD").enable();
        control.get("stateChangeHystresis").enable();
        control.get("minStateDuration").enable();
        control.get("confidenceTHD").enable();
        control.get("deviationRange").enable();
        control.get("preConfigCycleTime").enable();
        control.get("sampleWindow").enable();
      });


      // Disable EMICOnfigs
      const emi = this.deviceForm.get("eMICConfig") as FormArray;
      emi.controls.forEach((control) => {
        control.get("eMICName").disable();
      });

      this.deviceForm.get("deviceId").disable();
    } else {
      this.deviceForm.get("licensing").disable();
      this.deviceForm.get("meterSupplier").disable();

      this.deviceForm.get("oee").disable();
      this.deviceForm.get("deviceId").disable();

      const digitalPins = this.deviceForm.get("pins") as FormArray;
      digitalPins.controls.forEach((control) => {
        control.get("index").disable();
        control.get("pinName").enable();
        control.get("pinType").disable();
        control.get("partConfig").disable();
      });

      const inpins = this.deviceForm.get("inpins") as FormArray;
      inpins.controls.forEach((control) => {
        control.get("index").disable();
        control.get("inpinStatus").disable();
        control.get("inpinScanFrequency").disable();
        control.get("inpinPostFrequency").disable();
      });
      const pindebounce = this.deviceForm.get("pindebounce") as FormArray;
      pindebounce.controls.forEach((control) => {
        control.get("index").disable();
        control.get("io1").disable();
        control.get("io2").disable();
        control.get("io3").disable();
        control.get("io4").disable();
      });

      const outpins = this.deviceForm.get("outpins") as FormArray;
      outpins.controls.forEach((control) => {
        control.get("index").disable();
        control.get("outpinStatus").enable();
        control.get("outpinTimeDuration").disable();
      });

      // Disable analog signals
      const analogSignals = this.deviceForm.get("analog") as FormArray;
      analogSignals.controls.forEach((control) => {
        control.get("index").disable();
        control.get("analogName").enable();
        control.get("portType").disable();
        control.get("sensorOutputType").disable();
        control.get("channel").disable();
        control.get("upperLimit").disable();
        control.get("lowerLimit").disable();
        control.get("scaleFactor").disable();
        control.get("ctRatio").disable();
        control.get("divisionFactor").disable();
        control.get("multiFactor").disable();
      });

      // Disable CTs
      const cts = this.deviceForm.get("ct") as FormArray;
      cts.controls.forEach((control) => {
        // control.get("index").disable();
        // control.get("ctName").enable();
        control.get("ctRate").disable();
        control.get("ctStatus").disable();
        control.get("ctpartcountPin").disable();
        control.get("actualIdletime").disable();
        control.get("mode").disable();
        control.get("upperLimit").disable();
        control.get("upperSet").disable();
        control.get("lowerLimit").disable();
        control.get("lowerSet").disable();
      });

        const cSystem = this.deviceForm.get("curSystem") as FormArray; 
      cSystem.controls.forEach((control) => {
        control.get("index").disable();
        control.get("idleTHDmA").disable();
        control.get("minValidCurrent").disable();
        control.get("maxValidCurrent").disable();
        control.get("noiseVarienceTHD").disable();
        control.get("stateChangeHystresis").disable();
        control.get("minStateDuration").disable();
        control.get("confidenceTHD").disable();
        control.get("deviationRange").disable();
        control.get("preConfigCycleTime").disable();
        control.get("sampleWindow").disable();
      });


      // Disable EMICOnfigs
      const emi = this.deviceForm.get("eMICConfig") as FormArray;
      emi.controls.forEach((control) => {
        control.get("eMICName").disable();
      });
    }
  }

  onChange(event: any) {

  }

  edit(data: any) {
    this.isEdit = true;
    this.initializeForm1();
    if (data) {
      this.id = data.id;
      const {
        deviceId,
        machineId,
        deviceName,
        deviceType,
        deviceModelNo,
        deviceController,
        deviceMake,
        devicesupplier,
        deviceage,
        current,
        axis,
        spindle,
        voltage,
        oee,
        powerfactor,
        costperHour,
        targetPart,
        licensing,
        meterSupplier,
        meterModel,
        connectionType,
        partcountType,
        departmentName,
        departmentId,
        analogpostFreq,
        analogscanFreq
        // aiVersion
      } = data;
      if (this.loginRole == "SUPERADMIN") {
        let digitalPins = data.pins;
        let inPins = data.inpins;
        let pinDebounce = data.pindebounce;
        let outPins = data.outpins;
        let analogSignal = data.analog;
        let cts = data.ct;
        let cSystem = data.curSystem;
        let eMs = data.eMICConfig;

        const pins = this.deviceForm.get("pins") as FormArray;
        digitalPins?.forEach((item) => {
          pins.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              pinName: [item.pinName, [Validators.required]],
              pinType: [item.pinType, [Validators.required]],
              partConfig: [this.normalizePartConfigValue(item.partConfig)],
            })
          );
        });
        const inpins = this.deviceForm.get("inpins") as FormArray;
        inPins?.forEach((item) => {
          inpins.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              inpinStatus: [item.inpinStatus || 0, [Validators.required]],
              inpinPostFrequency: [item.inpinPostFrequency || 0, [Validators.required]],
              inpinScanFrequency: [item.inpinScanFrequency],
            })
          );
        });
        const pindebounce = this.deviceForm.get("pindebounce") as FormArray;
        pinDebounce?.forEach((item) => {
          pindebounce.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              io1: [item.io1 || 0, [Validators.required]],
              io2: [item.io2 || 0, [Validators.required]],
              io3: [item.io3 || 0, [Validators.required]],
              io4: [item.io4 || 0, [Validators.required]],
            })
          );
        });
        const outpins = this.deviceForm.get("outpins") as FormArray;
        outPins?.forEach((item) => {
          outpins.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              outpinStatus: [item.outpinStatus || 0, [Validators.required]],
              outpinTimeDuration: [item.outpinTimeDuration || 0, [Validators.required]],
            })
          );
        });
        const analog = this.deviceForm.get("analog") as FormArray;
        analogSignal?.forEach((item) => {
          analog.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              analogName: [item.analogName, [Validators.required]],
              portType: [item.portType, [Validators.required]],
              sensorOutputType: [
                Number(item.sensorOutputType),
                [Validators.required],
              ],
              channel: [item.channel, [Validators.required]],
              upperLimit: [
                item.upperLimit,
                [
                  Validators.pattern(/^\d*\.?\d*$/),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
              lowerLimit: [
                item.lowerLimit,
                [
                  Validators.pattern(/^\d*\.?\d*$/),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
              scaleFactor: [
                item.scaleFactor,
                [
                  Validators.pattern(/^\d*\.?\d*$/),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
              ctRatio: [
                item.ctRatio,
                [
                  Validators.pattern(/^\d*\.?\d*$/),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
              divisionFactor: [
                item.divisionFactor,
                [
                  Validators.pattern(/^\d*\.?\d*$/),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
              multiFactor: [
                item.multiFactor,
                [
                  Validators.pattern(/^\d*\.?\d*$/),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
            })
          );
        });
        const ct = this.deviceForm.get("ct") as FormArray;
        cts?.forEach((item) => {
          ct.push(
            this.formBuilder.group({
              // index: new FormControl({ value: item.index, disabled: true }),
              // ctName: [item.ctName, [Validators.required]],
              ctRate: [
                item.ctRate,
                [Validators.required, maxDigitsValidatorforConfig(4, 5)],
              ],
              ctStatus: [
                item.ctStatus || 0,
                [Validators.required, maxDigitsValidatorforConfig(4, 5)],
              ],
              ctpartcountPin: [
                item.ctpartcountPin || 0,
                [Validators.required, maxDigitsValidatorforConfig(4, 5)],
              ],
              actualIdletime: [
                item.actualIdletime || 0,
                [Validators.required, maxDigitsValidatorforConfig(4, 5)],
              ],
              mode: [item.mode || 1, [Validators.required]],
              upperLimit: [
                item.upperLimit,
                [
                  Validators.required,
                  Validators.pattern(
                    /^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/
                  ),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
              upperSet: [
                item.upperSet,
                [
                  Validators.required,
                  Validators.pattern(
                    /^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/
                  ),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
              lowerLimit: [
                item.lowerLimit,
                [
                  Validators.required,
                  Validators.pattern(
                    /^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/
                  ),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
              lowerSet: [
                item.lowerSet,
                [
                  Validators.required,
                  Validators.pattern(
                    /^\d{1,4}(\.\d{1,3}[05]?|\.([05]0?|00))?$/
                  ),
                  maxDigitsValidatorforConfig(4, 5),
                ],
              ],
            })
          );
        });
        const curSystem = this.deviceForm.get("curSystem") as FormArray;
        cSystem?.forEach((item) => {
          curSystem.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              idleTHDmA: [item.idleTHDmA || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
              minValidCurrent: [item.minValidCurrent || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
              maxValidCurrent: [item.maxValidCurrent || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
              noiseVarienceTHD: [item.noiseVarienceTHD || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
              stateChangeHystresis: [item.stateChangeHystresis || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
              minStateDuration: [item.minStateDuration || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
              confidenceTHD: [item.confidenceTHD || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
              deviationRange: [item.deviationRange || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
              preConfigCycleTime: [item.preConfigCycleTime || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
              sampleWindow: [item.sampleWindow || 0, [Validators.required, maxDigitsValidatorforConfig(8, 5)]],
            })
          );
        });
        const eM = this.deviceForm.get("eMICConfig") as FormArray;
        eMs?.forEach((item, index) => {
          const formGroup = this.formBuilder.group({
            eMICName: [item.eMICName || '', [Validators.required]],
            eMICType: [item.eMICType || '', [Validators.required]],
          });

          if (eM.at(index)) {
            // If the form group already exists at the index, update it
            eM.at(index).patchValue(formGroup.value);
          } else {
            // If the form group doesn't exist, add a new one
            eM.push(formGroup);
          }
        });
      } else {
        let digitalPins = data.pins;
        let inPins = data.inpins;
        let pinDebounce = data.pindebounce;
        let outPins = data.outpins;
        let analogSignal = data.analog;
        let cts = data.ct;
        let cSystem = data.curSystem;
        let eMs = data.eMICConfig;

        const pins = this.deviceForm.get("pins") as FormArray;
        digitalPins?.forEach((item) => {
          pins.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              pinName: [item.pinName, [Validators.required]],
              pinType: new FormControl({ value: item.pinType, disabled: true }),
              partConfig: new FormControl({
                value: item.partConfig,
                disabled: true,
              }),
            })
          );
        });


        const inpins = this.deviceForm.get("inpins") as FormArray;
        inPins?.forEach((item) => {
          inpins.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              inpinStatus: [item.inpinStatus, [Validators.required]],
              inpinScanFrequency: new FormControl({ value: item.inpinScanFrequency, disabled: true }),
              inpinPostFrequency: new FormControl({
                value: item.inpinPostFrequency,
                disabled: true
              }),
            })
          );
        });
        const pindebounce = this.deviceForm.get("pindebounce") as FormArray;
        pinDebounce?.forEach((item) => {
          pindebounce.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              io1: [item.io1 || 0, [Validators.required]],
              io2: [item.io2 || 0, [Validators.required]],
              io3: [item.io3 || 0, [Validators.required]],
              io4: [item.io4 || 0, [Validators.required]],
            })
          );
        });
        const outpins = this.deviceForm.get("outpins") as FormArray;
        outPins?.forEach((item) => {
          outpins.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              outpinStatus: [item.outpinStatus, [Validators.required]],
              outpinTimeDuration: new FormControl({ value: item.outpinTimeDuration, disabled: true }),
            })
          );
        });

        const analog = this.deviceForm.get("analog") as FormArray;
        analogSignal?.forEach((item) => {
          analog.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              analogName: [item.analogName, [Validators.required]],
              portType: new FormControl({
                value: item.portType,
                disabled: true,
              }),
              sensorOutputType: new FormControl({
                value: Number(item.sensorOutputType),
                disabled: true,
              }),
              channel: new FormControl({
                value: item.channel,
                disabled: true,
              }),
              upperLimit: new FormControl({
                value: item.upperLimit,
                disabled: true,
              }),
              lowerLimit: new FormControl({
                value: item.lowerLimit,
                disabled: true,
              }),
              scaleFactor: new FormControl({
                value: item.scaleFactor,
                disabled: true,
              }),
              multiFactor: new FormControl({
                value: item.multiFactor,
                disabled: true,
              }),
              divisionFactor: new FormControl({
                value: item.divisionFactor,
                disabled: true,
              }),
              ctRatio: new FormControl({
                value: item.ctRatio,
                disabled: true,
              })
            })
          );
        });
        const ct = this.deviceForm.get("ct") as FormArray;
        cts?.forEach((item) => {
          ct.push(
            this.formBuilder.group({
              // index: new FormControl({ value: item.index, disabled: true }),
              // ctName: [item.ctName, [Validators.required]],
              ctRate: new FormControl({ value: item.ctRate, disabled: true }),
              actualIdletime: new FormControl({
                value: item.actualIdletime,
                disabled: true,
              }),

              mode: new FormControl({ value: item.mode, disabled: true }),
              upperLimit: new FormControl({
                value: item.upperLimit,
                disabled: true,
              }),
              upperSet: new FormControl({
                value: item.upperSet,
                disabled: true,
              }),
              lowerLimit: new FormControl({
                value: item.lowerLimit,
                disabled: true,
              }),
              lowerSet: new FormControl({
                value: item.lowerSet,
                disabled: true,
              }),
              ctpartcountPin: new FormControl({
                value: item.ctpartcountPin,
                disabled: true,
              }),
              ctStatus: new FormControl({
                value: item.ctStatus,
                disabled: true,
              }),

            })
          );
        });
        const curSystem = this.deviceForm.get("curSystem") as FormArray;
        cSystem?.forEach((item) => {
          curSystem.push(
            this.formBuilder.group({
              index: new FormControl({ value: item.index, disabled: true }),
              idleTHDmA: new FormControl({ value: item.idleTHDmA, disabled: true }),
              minValidCurrent: new FormControl({ value: item.minValidCurrent, disabled: true }),
              maxValidCurrent: new FormControl({ value: item.maxValidCurrent, disabled: true }),
              noiseVarienceTHD: new FormControl({ value: item.noiseVarienceTHD, disabled: true }),
              stateChangeHystresis: new FormControl({ value: item.stateChangeHystresis, disabled: true }),
              minStateDuration: new FormControl({ value: item.minStateDuration, disabled: true }),
              confidenceTHD: new FormControl({ value: item.confidenceTHD, disabled: true }),
              deviationRange: new FormControl({ value: item.deviationRange, disabled: true }),
              preConfigCycleTime: new FormControl({ value: item.preConfigCycleTime, disabled: true }),
              sampleWindow: new FormControl({ value: item.sampleWindow, disabled: true }),
            })
          );
        });


        const eM = this.deviceForm.get("eMICConfig") as FormArray;
        eMs?.forEach((item) => {
          eM.push(
            this.formBuilder.group({
              eMICName: [item.eMICName, [Validators.required]],
              eMICType: [item.eMICType, [Validators.required]],
            })
          );
        });
      }

      this.deviceForm.patchValue({
        deviceId: deviceId || "",
        machineId: machineId || "",
        deviceName: deviceName || "",
        deviceType: deviceType || [""],
        deviceModelNo: deviceModelNo || "",
        deviceController: deviceController || "",
        deviceMake: deviceMake || "",
        devicesupplier: devicesupplier || "",
        deviceage: deviceage || "",
        powerfactor: powerfactor || "",
        costperHour: costperHour || 0,
        voltage: voltage || "",
        current: current || "",
        axis: axis || 0,
        spindle: spindle || 0,
        oee: oee || [""],
        targetPart: targetPart || 0,
        licensing: licensing || [3],
        meterModel: meterModel || "",
        meterSupplier: meterSupplier || "",
        connectionType: connectionType || "",
        partcountType: partcountType || "",
        departmentName: departmentName || "",
        departmentId: departmentId || "",
        analogpostFreq: analogpostFreq || "",
        analogscanFreq: analogscanFreq || "",
        // aiVersion: aiVersion || "",
        transmissionFrequency: 30,
      });
      if (this.loginRole == "CUSTOMER") {
        this.custId = data.custId;
        this.deviceForm.get("licensing").disable();
        this.deviceForm.get("meterSupplier").disable();
        this.deviceForm.get("oee").disable();
      }
      this.deviceForm.get("deviceId").disable();
      this.isAdd = true;
    }
  }

  cancel() {
    // this.deviceForm.reset()
    this.typesubmit = false;
    this.isAdd = false;
    this.isEdit = false;
  }

  delete(id, deviceId) {
    if (this.loginRole == "SUPERADMIN") {
      this.dataservice.delete("api/device/" + id).subscribe((res) => {
        if (res) {
          this.toastr.success("Machine deleted Successfully");

          this.deleteCertificate(deviceId);
          this.modalService.dismissAll();
          this.custDevices(this.custId);
        }
      });
    }
  }

  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }

  openModal(infotemplate: any, act: any) {
    this.isAdd = false;
    this.modalService.open(infotemplate, { centered: true });
    this.machineTypeform = this.formBuilder.group({
      deviceType: ["", [Validators.required]],
      description: ["", [Validators.required]],
    });
    // Edit
    // if (data) {
    //   this.id = data.id
    //   this.pathValue(this.machineTypeform, data);
    // }
  }

  pathValue(formGroup: FormGroup, data: any): void {
    const controls = formGroup.controls;
    for (const key in controls) {
      controls[key].patchValue(data[key]);
    }
  }

  getMachineType() {
    this.machineTypeList = [];
    this.dataservice.get("api/deviceType").subscribe((res: any) => {

      if (res) {
        let machineTypeList = res;
        machineTypeList.forEach((element) => {
          this.machineTypeList.push(element.deviceType);
        });
      } else {
        this.machineTypeList = [];
      }
    });
  }

  saveData() {
    this.submit = true;
    if (this.machineTypeform.invalid) {
      return;
    } else {

      this.dataservice
        .post("api/deviceType", this.machineTypeform.value)
        .subscribe((res) => {

          if (res) {
            this.toastr.success("Machine Type added Successfully");
            this.cancelModal();
            this.getMachineType();
          }
        });
    }
  }
  deviceId;
  openModalDelete(deletetemp, id, item) {
    this.delMachId = id;
    this.deviceId = item["deviceId"];
    this.modalService.open(deletetemp, { centered: true });
  }

  cancelModal() {
    this.machineTypeform.reset();
    this.modalService.dismissAll();
    this.submit = false;
  }
  openFormula() {
    this.router.navigate(["/formula", { id: this.custId }]);
  }
  openProcessMasterlist() {
    this.router.navigate(["/processlist", { id: this.custId }]);
  }
  openCategory() {
    this.router.navigate(["/category", { id: this.custId }]);
  }
}


